import { type FC } from "react";
import { Card, CardHeader, CardContent, Skeleton } from "@mui/material";
import {
  MapChart,
  type MapChartCountryDatum,
} from "@/partner/shared/components/MapChart";
import { ErrorMessage } from "@/shared/components";

interface MapChartCardProps {
  title: string;
  data?: MapChartCountryDatum[];
  field: string;
  loading?: boolean;
  /**
   * Ошибка от useQuery этого виджета — показывается вместо карты, чтобы
   * пустая карта не читалась как «нет данных» (спека, раздел 5).
   */
  error?: unknown;
  chartHeight?: number;
}

export const MapChartCard: FC<MapChartCardProps> = ({
  title,
  data,
  field,
  loading,
  error,
  chartHeight = 350,
}) => {
  if (error) {
    return (
      <Card sx={{ width: "100%" }}>
        <CardHeader title={title} />
        <CardContent sx={{ pt: 0 }}>
          <ErrorMessage error={error} />
        </CardContent>
      </Card>
    );
  }

  if (loading || !data) {
    return (
      <Card sx={{ width: "100%" }}>
        <CardHeader title={title} />
        <CardContent sx={{ pt: 0 }}>
          <Skeleton variant="rectangular" height={chartHeight} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ width: "100%" }}>
      <CardHeader title={title} />
      <CardContent sx={{ pt: 0 }}>
        <MapChart data={data} field={field} />
      </CardContent>
    </Card>
  );
};
